import React from 'react';
import { Dialog, DialogContentWrapper, DialogTitle, DialogDescription, DialogFooter, SwagButton, Typography } from '@ezetech/swag-space-x';
import { variables } from 'swag-client-common/styles/variables-js';
import css from './space-styled-confirm-popup.scss';
export const SpaceStyledConfirmPopup = props => {
  const {
    open,
    title = 'Confirm Action',
    text = 'Are you sure you want to continue?',
    confirmBtnText = 'Confirm',
    cancelBtnText = 'Cancel',
    onCloseClick,
    onConfirmClick
  } = props;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onOpenChange: onCloseClick
  }, /*#__PURE__*/React.createElement(DialogContentWrapper, {
    className: css.dialogContentWrapperClassName,
    overlayClassName: css.dialogOverlayClassName
  }, /*#__PURE__*/React.createElement(DialogTitle, null, title), /*#__PURE__*/React.createElement(DialogDescription, null, /*#__PURE__*/React.createElement(Typography, {
    color: variables.colorSubduedText,
    fontType: "bodyMd"
  }, text)), /*#__PURE__*/React.createElement(DialogFooter, {
    className: css.footer
  }, /*#__PURE__*/React.createElement(SwagButton, {
    type: "outlined",
    onClick: onCloseClick
  }, cancelBtnText), /*#__PURE__*/React.createElement(SwagButton, {
    type: "primary",
    onClick: onConfirmClick
  }, confirmBtnText))));
};